export default {
  type: 'plan',
  config: {
    relationships: {
      payer: {
        type: 'payer'
      },
      networks: {
        type: 'network'
      },
      fee_schedules: {
        type: 'fee_schedule'
      },
      required_health_plans: {
        type: 'plan'
      },
      providers: {
        type: 'provider'
      }
    }
  }
};
//# sourceMappingURL=plan.js.map